/**
 * Construye el endpoint al que se va a hacer la llamada
 * la url esta compuesta por el nombre del servicio, el idtag, el nombre del diccionario y el hash
 */

import { cleanUrlForHash } from './cleanUrlForHash'
import { DICTIONARY_CONFIG } from './config'
import sha1 from 'sha1'

const { dictionaryName, idTag, serviceName } = DICTIONARY_CONFIG

const generateHash = () => sha1(cleanUrlForHash())

export const urlToDictionaryCall = `${serviceName}${idTag}${dictionaryName}${generateHash()}`
